/* shah */
import React from 'react'

const UsefulLinksIcon = () => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="15" height="15" viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">
            <metadata>
                Created by potrace 1.16, written by Peter Selinger 2001-2019
            </metadata>
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M3864 5110 c-138 -25 -292 -89 -420 -175 -93 -63 -889 -854 -915
-910 -50 -107 3 -247 110 -292 45 -19 129 -18 177 2 27 11 164 140 454 429
407 404 417 413 500 454 161 78 319 90 480 36 196 -66 337 -209 406 -409 37
-110 40 -255 6 -365 -52 -165 -30 -141 -831 -941 l-736 -736 -85 -41 c-252
-121 -511 -82 -728 111 -76 68 -166 85 -247 48 -82 -37 -126 -106 -127 -196
-1 -76 28 -131 103 -196 210 -184 436 -270 709 -270 233 -1 408 51 605 179 52
33 256 231 799 771 413 411 753 759 785 801 105 140 174 302 201 472 18 111 9
331 -19 435 -99 380 -388 670 -769 774 -87 23 -367 35 -458 19z"/>
                <path d="M2084 3329 c-74 -12 -210 -57 -279 -91 -152 -77 -184 -105 -869 -787
-376 -374 -693 -699 -725 -741 -105 -140 -174 -302 -201 -472 -18 -111 -9
-331 19 -435 67 -257 227 -482 444 -627 172 -114 336 -166 550 -174 253 -9
434 41 642 176 93 60 779 739 806 797 49 105 -4 247 -108 291 -43 19 -135 18
-181 -1 -24 -11 -154 -133 -387 -364 -379 -377 -402 -395 -555 -443 -110 -34
-255 -31 -365 6 -199 68 -344 212 -409 406 -54 161 -42 318 36 480 l41 85 681
681 681 681 85 41 c162 78 318 90 477 37 93 -32 149 -64 231 -133 75 -64 115
-82 179 -82 83 1 162 50 197 124 23 49 21 140 -5 193 -40 82 -231 223 -392
289 -131 53 -248 74 -407 73 -74 -1 -158 -5 -186 -10z"/>
            </g>
        </svg>
    )
}

export default UsefulLinksIcon